// export const BASE_URL = 'http://iedcbackend.ashermathews.co'



export const BASE_URL = 'https://backend.iedctkmce.com'


export const S3_URL = 'https://iedcbackend.s3.amazonaws.com/media'
